import { createFileRoute } from '@tanstack/react-router';

import { TravelAnalytics } from '@/module/Travel/Registry/TravelAnalytics';

export const Route = createFileRoute('/_auth/travel/_travel/analytics/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelAnalytics />;
}
